export default __webpack_public_path__ + "static/media/next-profile-path.a0235532.svg";